var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-combobox",
    {
      ref: "combobox",
      attrs: {
        dense: "",
        filled: "",
        outlined: "",
        clearable: !_vm.isDialpad,
        label: _vm.phoneLabel,
        rules: _vm.computedRules,
        placeholder: _vm.phonePlaceholder,
        items: _vm.filteredItems,
        "item-value": "value",
        "item-text": "title",
        "return-object": false,
      },
      on: { "update:search-input": _vm.onUpdateSearch },
      model: {
        value: _vm.phoneValue,
        callback: function ($$v) {
          _vm.phoneValue = $$v
        },
        expression: "phoneValue",
      },
    },
    [
      _c(
        "template",
        { slot: "prepend-inner" },
        [
          _c("vue-tel-input-vuetify", {
            attrs: {
              "only-countries": _vm.availableCountries,
              "default-country": _vm.phoneDefaultCountry,
              "append-icon": "mdi-chevron-down",
              dense: "",
              "disabled-fetching-country": "",
              "select-classes": "select-phone",
              "text-field-classes": "input-phone",
            },
            on: { input: _vm.onPhoneInput },
            model: {
              value: _vm.phoneValue,
              callback: function ($$v) {
                _vm.phoneValue = $$v
              },
              expression: "phoneValue",
            },
          }),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }